// extracted by mini-css-extract-plugin
export default {"empty":"styles_empty__RFmEg","empty__title":"styles_empty__title__3HV25","empty__subtitle":"styles_empty__subtitle__ro9S3"};